import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	loading?: boolean;
}

const LoadingButton: React.FC<Props> = ({
	children,
	className,
	disabled = false,
	loading = false,
	onClick = noop,
	...rest
}) => (
	<button
		disabled={loading || disabled}
		className={classnames(`focus:_outline-none _flex _flex-grow _justify-center`, className, {
			'_cursor-not-allowed': loading || disabled,
		})}
		onClick={onClick}
		{...rest}
	>
		{loading && <div className="_mr-2 _btn-spinner" />}
		{children}
	</button>
);

export default LoadingButton;
